type GenderT = 'FEMALE' | 'MALE';
type CompanyT = {companyId: number; companyName: string};

const RoleEnumEngMap = {
    ROLE_1: '총관리자',
    ROLE_2: '관리자',
    ROLE_3: '구성원',
};
type RoleEngT = keyof typeof RoleEnumEngMap;

const enum RoleE {
    /** 총관리자 */
    'GeneralManager' = 'ROLE_1',
    /** 관리자 */
    'ReservationManager' = 'ROLE_2',
    /** 구성원 */
    'BusinessMember' = 'ROLE_3',
}

type LoginWithEmailPasswordResponseT = {
    phoneNumber: string;
    loginToken: string;
};

type LoginWithSMSCodeResponseT = {
    accessToken: string;
    refreshToken: string;
    accessTokenExpireMills: number; // NOTE: milliseconds
    refreshTokenExpireMills: number; // NOTE: milliseconds
};

type MyInfoT = {
    staffId: number;
    /**
     * 회원번호. staffId(담당자 ID)와 다른 값이다.
     * 비즈포인트 정산내역 엑셀 2차 인증(POST /users/{userId}/authenticate)이 이 값을 받는다.
     */
    userId: number;
    companyId: number;
    companyName: string;
    email: string;
    name: string;
    maskedName: string;
    phone: string;
    role: RoleE;
    hasPointContract: boolean;
};

type CompanyListByEmailResponseT = {
    email: string;
    companies: CompanyT[];
};

type RegisterInfoResponseT = {
    email: string;
    companyName: string;
    nicknames: string[];
};

type RegisterUserResponseT = {
    email: string;
    companyId: number;
    nickname: string;
    name: string;
    gender: GenderT;
    dob: string;
    privacyAuxiliaryPolicy: boolean;
    marketingAcceptance: boolean;
    locationPolicy: boolean;
};

export type {
    RoleEngT,
    GenderT,
    CompanyT,
    LoginWithEmailPasswordResponseT,
    LoginWithSMSCodeResponseT,
    MyInfoT,
    CompanyListByEmailResponseT,
    RegisterInfoResponseT,
    RegisterUserResponseT,
};

export {RoleEnumEngMap, RoleE};
